import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { copyTextToClipboard } from 'utilities/shared/copyTextToClipboard';

export const useClipboard = () => {
  return useCallback(async (text: string) => {
    await copyTextToClipboard(text);
    toast(`${text} has been copied to the clipboard`);
  }, []);
};
